import { useSelector } from "react-redux";
import { Badge, Group, HoverCard, Tooltip} from '@mantine/core';
import intl from "react-intl-universal";
import { ReactElement, JSXElementConstructor, ReactNode, ReactPortal, Key } from "react";

export function DocSignCountbyUser(props:any) {

  const inituser = useSelector((state: any) => state.user.meetinguser)
  const initdocstosign = useSelector((state: any) => state.user.userhavetosigndocs)


  // Anzahl der User die dieses Dokument unterschreiben sollen 
  const countsigner = initdocstosign.filter((obj: { resourceId: any; }) => {
       return obj.resourceId === props.resourceId;
    });

  const usersHaveToSignIds = new Set(
    countsigner.flatMap((item: any) => item.user)
  );



   const usersHaveToSign = inituser
     .filter((u: any) => usersHaveToSignIds.has(u.userId))
    .map((u: any) => ({
      firstName: u.firstName,
      lastName: u.lastName,
  }));




  const usersAreSelected = inituser.filter((u: any) => usersHaveToSignIds.has(u.userId));

    //console.log("usersHaveToSignIds:",usersHaveToSignIds)
    //console.log("inituser:",inituser)
    //console.log("usersAreSelected:",usersAreSelected[0].documents)


 let userCount = 0
 if (countsigner[0] && countsigner[0].user) {
    userCount = countsigner[0].user.length;
  }

  // Welche User haben das Dokument schon unterschrieben
  let counter = 0;

  usersAreSelected.forEach((item: { documents: any[]; }) => {
    if (item.documents) {
      item.documents.forEach(document => {
        if (document.resourceId === props.resourceId && document.isSigned) {
          //console.log("item.documents.inside", document.isSigned);
          counter++;
        }
      });
    }
  });


  return (
    <>
    <Group>
     
      <HoverCard width={400} shadow="md">
        <HoverCard.Target>
            <Badge color="gray" variant="outline">{userCount}</Badge>
            </HoverCard.Target>
            <HoverCard.Dropdown>
               <ul style={{ margin: 0, paddingLeft: 16 }}>
                {usersHaveToSign.map((u: { firstName: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined; lastName: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined; }, index: Key | null | undefined) => (
                  <li key={index}>
                  {u.firstName} {u.lastName}
              </li>
           ))}
    </ul>
            </HoverCard.Dropdown>
            </HoverCard>
      <Tooltip label={intl.get('SIGDOCCOUNTBYUSER_ALL_DONE')} multiline={true}>
        <Badge color="gray" variant="outline">{counter}</Badge>
      </Tooltip>
   </Group>
    </>
  );
}